<template>
  <div>
    <br>
    <v-container fluid :class=" $vuetify.breakpoint.xs ? 'imagen-fondo' : 'pl-0 pr-0 pb-0 mt-13 imagen-fondo'">
      <!--IMAGE RADA PRINCIPAL  -->
      <!-- <v-row no-gutters>
        <v-img
          src="assets/images/banner3.webp"
          gradient="to top right, rgba(100,115,201,.33), rgba(25,32,72,.7)"
          :height="(imageHeight + 2) + 'px'"
          :style="'margin-top: ' + $vuetify.application.top + 'px;'"
        >
          <v-theme-provider dark>
            <v-container fill-height>
              <v-row align="center" class="white--text mx-auto" justify="center">
                <v-col class="white--text text-center" cols="12" tag="h1">
                  <a>
                    <img src="assets/images/rada_center_banner.webp" alt="#RadaRentaCar" width="400" height="450">
                  </a>
                </v-col>
                <v-btn class="align-self-end" fab x-large outlined @click="$vuetify.goTo('#reserva')">
                  <v-icon dark>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-img>
      </v-row> -->
      <v-row :no-gutters="$vuetify.breakpoint.xs" :class="$vuetify.breakpoint.xs ? 'pt-12' : 'pt-12'">
        <v-col cols="12" md="9" sm="12" class="pa-0" align="center">
          <v-card flat class="transparent-card">
            <v-card-title class="pl-8 pb-4">
              <p class="white--text mb-3" style="font-size: xx-large; font-weight: bold; word-break: normal; line-height: 1.2;">{{ $t('alquila_tu_auto_ahora') }}</p>
            </v-card-title>
            <v-card-text class="pt-2 pb-0">
              <radaVertical />
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" sm="3" class="pa-0" v-if="!$vuetify.breakpoint.xs">
          <v-img src="/assets/images/rada_home.webp" class="scaled-image"></v-img>
        </v-col>
      </v-row>
    </v-container>
    <br v-if="!$vuetify.breakpoint.xs">
    <!-- Reserva / Carrousel  -->
    <section id="reserva" :style=" $vuetify.breakpoint.xs ? '' : 'margin-top: -15px;'">
      <v-row no-gutters>
        <!-- <v-col cols="12" md="8" xl="7" class="mt-2">
          <radaVertical/>
        </v-col> -->
        <v-col cols="12" class="align-center">
          <v-carousel
            height="auto"
            interval="3000"
            delimiter-icon="mdi-minus"
            :show-arrows="false"
            hide-delimiter-background
            continuous
            cycle
            light
            class="ma-0 pa-0"
          >
            <v-carousel-item
              v-for="(imagen, index) in bannerImagenes" :key="index"
              :src="imagen.url"
              contain
            ></v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </section>
    <!-- FLOTA  -->
    <v-row class="d-flex justify-center" style="background-color: #F5F5F5">
      <v-col cols="12" sm="10" md="8" xl="7" class="pb-0 pt-16">
        <div class="section-header text-center px-4">
          <h3>{{ $t("amplia_gama") }}</h3>
          <p>{{ $t("amplia_gama_body") }}</p>
        </div>
      </v-col>
      <v-col cols="12" class="pt-0" align="center">
        <v-container class="pt-0">
          <v-row no-gutters>
            <CardCars/>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <!-- Features -->
    <v-row class="d-flex justify-center mt-16 px-4" style="cursor: default;">
      <v-col cols="12" class="pb-0">
        <div class="section-header text-center">
          <h3 class="section-title custom-title">{{ $t("mejor_experiencia") }}</h3>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pt-0">
        <div class="icon-item text-center" style="height: 90%">
          <div class="icon"><i class="fa fa-user"></i></div>
          <div class="content">
            <h4>{{ $t("personal_capacitado") }}</h4>
            <p>{{ $t("personal_capacitado_body") }}</p>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pt-0">
        <div class="icon-item text-center" style="height: 90%">
          <div class="icon"><i class="fa fa-car"></i></div>
          <div class="content">
            <h4>{{ $t("servicio_excelencia") }}</h4>
            <p>{{ $t("servicio_excelencia_body") }}</p>
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="4" class="pt-0">
        <div class="icon-item text-center" style="height: 90%">
          <div class="icon"><i class="fa fa-volume-control-phone"></i></div>
          <div class="content">
            <h4>{{ $t("atencion_cliente") }}</h4>
            <p>{{ $t("atencion_cliente_1") }}</p>
          </div>
        </div>
      </v-col>
    </v-row>

    <!-- Sucursales -->
    <v-row class="d-flex justify-center mt-12 mb-12 px-4" style="cursor: default;">
      <v-col cols="12" class="pb-2">
        <div class="section-header text-center">
          <h3 class="section-title custom-title">{{ $t("nuestras_sucursales") }}</h3>
          <p>{{ $t("sucursales_subtitulo") }}</p>
        </div>
      </v-col>
      <v-col cols="12" sm="11" md="10" lg="9" class="pt-0">
        <v-row class="justify-center">
          <v-col
            v-for="(sucursal, index) in sucursales"
            :key="index"
            cols="6"
            sm="4"
            md="3"
            class="d-flex"
          >
            <div class="sucursal-card w-100">
              <div class="sucursal-img-wrapper">
                <img
                  :src="sucursal.imagen"
                  :alt="'Sucursal ' + sucursal.nombre"
                  class="sucursal-img"
                  loading="lazy"
                />
              </div>
              <div class="sucursal-body text-center">
                <h5 class="sucursal-title">{{ sucursal.nombre }}</h5>
                <a
                  :href="'tel:' + sucursal.telefono"
                  class="sucursal-phone"
                  :title="'Llamar a sucursal ' + sucursal.nombre"
                >
                  <i class="fa fa-phone mr-1"></i>
                  <span>{{ sucursal.telefono }}</span>
                </a>
                <div class="mt-2">
                  <a
                    :href="getWhatsappUrl(sucursal.nombre, sucursal.telefono)"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="sucursal-whatsapp-link"
                    :title="'WhatsApp sucursal ' + sucursal.nombre"
                  >
                    <i class="fa fa-whatsapp mr-1"></i> WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { storage } from "@/firebase"
import radaVertical from './rada-vertical'
import CardCars from "../components/CardCars.vue"

export default {
  name: "Home",
  components: {
    CardCars,
    radaVertical
  },
  data: () => ({
    imageHeight: 0,
    bannerImagenes: [],
    iframeCountKey: 0,
    serviceFeatures: [
      {
        title:'Personal Capacitado',
        image:'',
        description:'Contamos con el mejor equipo de trabajo,totalmente capacitado para brindarte el mejor servicio.'
      }
    ],
    sucursales: [
      {
        nombre: 'Salta',
        imagen: '/assets/images/sucursales/salta.webp',
        telefono: '+5493876630301'
      },
      {
        nombre: 'Jujuy',
        imagen: '/assets/images/sucursales/jujuy.webp',
        telefono: '+5493876630301'
      },
      {
        nombre: 'Ushuaia',
        imagen: '/assets/images/sucursales/ushuaia.webp',
        telefono: '+5493876630301'
      },
      {
        nombre: 'Calafate',
        imagen: '/assets/images/sucursales/calafate.webp',
        telefono: '+5493876630301'
      },
      {
        nombre: 'Bariloche',
        imagen: '/assets/images/sucursales/bariloche.webp',
        telefono: '+5493876630301'
      },
      {
        nombre: 'Mendoza',
        imagen: '/assets/images/sucursales/mendoza.webp',
        telefono: '+5493876630301'
      },
      {
        nombre: 'Buenos Aires',
        imagen: '/assets/images/sucursales/buenosaires.webp',
        telefono: '+5493876630301'
      },
      {
        nombre: 'Iguazú',
        imagen: '/assets/images/sucursales/iguazu.webp',
        telefono: '+5493876630301'
      }
    ],
    height: '100%',
    width: '100%'
  }),
  created() {
    this.getImagenes();
  },
  mounted() {
    this.setImageHeight()
    window.addEventListener('resize', this.setImageHeight)
  },
  methods: {
    getWhatsappUrl(nombre, telefono) {
      const cleanPhone = telefono.replace('+', '');
      const msg = encodeURIComponent(`Hola! Quisiera consultar por el alquiler de un vehículo en la sucursal de ${nombre}`);
      return `https://api.whatsapp.com/send?phone=${cleanPhone}&text=${msg}`;
    },
    getImagenes() {
      let arrayTempImg = [];
      // Creamos una referencia a la carpeta de la cual queremos obtener sus imagenes
      var listRef = storage.ref().child("/imagenes/promociones_home");
      //Mediante un ciclo obtenemos el listado de imagenes
      listRef
        .listAll()
        .then(function(res) {
          res.items.forEach(function(itemRef) {
            itemRef
              .getDownloadURL()
              .then(function(url_img) {
                //guardamos las url de las imagenes en un array temporal
                arrayTempImg.push({
                  url: url_img
                });
              })
              .catch(function(error) {
                console.log(error);
              });
          });
        })
        .catch(function(error) {
          console.log(error);
        });
      this.bannerImagenes = arrayTempImg;
    },
    setImageHeight() {
      this.imageHeight = window.innerHeight
    }
  }
};
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css2?family=Carter+One&family=Londrina+Sketch&display=swap');

.rada-title {
    font-family: 'Carter One', sans-serif;
    color: white;
    font-weight: 300;
} */
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif !important;
} */

.card-content {
  flex-direction: column;
  justify-content: start;
}

.image-contain img {
  object-fit: cover;
  width: 250px;
  height: 150px;
  margin-bottom: 0;
}

.no-margin {
  margin-top: 0;
  padding-top: 0;
}

.imagen-fondo {
  /* background: linear-gradient(to top right, rgba(100, 115, 201, 0.33), rgba(25, 32, 72, 0.7)),  url('/assets/images/home.webp'); */
  background-image: url('/assets/images/home.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
}

.transparent-card {
  background-color: transparent; /* Fondo transparente */
  box-shadow: none; /* Elimina las sombras de la tarjeta */
}

.scaled-image {
  transform: scale(0.8); /* Escala al 80% del tamaño original */
  transform-origin: center; /* Mantiene la posición centrada */
}

.custom-title {
  text-transform: none;
}

.sucursal-card {
  background: #ffffff;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  transition: transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease;
}

.sucursal-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 22px rgba(0, 0, 0, 0.12);
  border-color: #cbd5e1;
}

.sucursal-img-wrapper {
  position: relative;
  width: 100%;
  height: 115px;
  overflow: hidden;
  background-color: #f1f5f9;
}

.sucursal-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.4s ease;
}

.sucursal-card:hover .sucursal-img {
  transform: scale(1.08);
}

.sucursal-body {
  padding: 10px 8px 12px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  justify-content: space-between;
}

.sucursal-title {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 4px;
}

.sucursal-phone {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 600;
  color: #e53935;
  text-decoration: none;
  transition: color 0.2s;
  white-space: nowrap;
}

.sucursal-phone i {
  font-size: 12px;
  color: #e53935;
}

.sucursal-phone:hover {
  color: #b71c1c;
  text-decoration: underline;
}

.sucursal-whatsapp-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  color: #ffffff !important;
  background-color: #25d366;
  padding: 3px 12px;
  border-radius: 12px;
  text-decoration: none;
  transition: background-color 0.2s, transform 0.15s;
}

.sucursal-whatsapp-link:hover {
  background-color: #128c7e;
  transform: scale(1.04);
  text-decoration: none;
}

.sucursal-whatsapp-link i {
  font-size: 13px;
}

</style>